import { defineStore } from 'pinia';
import Credential from '../Api/Credential';
import MercadoLibreService from '../Api/MercadoLibreService';
import Walmart from '../Api/Walmart';
import { ref } from 'vue';

const _amazonCredentials = new Credential("amazon")
const _mercadolibreCredentials = new Credential("mercadolibre")
const _walmartCredentials = { cuentas: [], cuentaActiva: null }

export const useMarketplaceCredentials = defineStore('marketplaceCredentials', () => {
    const amazonCredentials = ref({})
    const mercadolibreCredentials = ref({})
    const walmartCredentials = ref({}) // Estado reactivo para las credenciales de Walmart

    const setAmazonCredentials = (credentials) => {
        amazonCredentials.value = credentials
    }
    const setMercadolibreCredentials = (credentials) => {
        mercadolibreCredentials.value = credentials
    }
    const setWalmartCredentials = (credentials) => { // Nueva función para establecer credenciales de Walmart
        walmartCredentials.value = credentials
    }

    (async () => {
        let promises = [
            _amazonCredentials.getCredentials().catch(err => err.response),
            _mercadolibreCredentials.getCredentials().catch(err => err.response),
            Walmart.getCredentials()
                .then(res => {
                    _walmartCredentials.cuentas = res.data || [];
                    _walmartCredentials.cuentaActiva = _walmartCredentials.cuentas.find(c => c.isActive) || null;
                })
                .catch(err => err?.response)
        ];

        await Promise.all(promises).then(async () => {
            const mlCuentas = Array.isArray(_mercadolibreCredentials.cuentas)
                ? _mercadolibreCredentials.cuentas
                : Object.values(_mercadolibreCredentials.cuentas || {});
            if (!mlCuentas.length) return;

            const entriesWithUserId = mlCuentas
                .map((cuenta) => ({ cuenta, userId: cuenta?.data?.User_id }))
                .filter((e) => e.userId);

            const userInfoPromises = entriesWithUserId.map((e) =>
                MercadoLibreService.getUserInfo(e.userId).catch((err) => err?.response)
            );
            const userInfoResults = await Promise.all(userInfoPromises);

            entriesWithUserId.forEach((entry, index) => {
                const result = userInfoResults[index];
                if (entry.cuenta?.data && result?.data) {
                    entry.cuenta.data.user_info = result.data;
                }
            });

            const cuentasArray = (c) => (Array.isArray(c) ? c : Object.values(c || {}));
            _mercadolibreCredentials.cuentaActiva = cuentasArray(_mercadolibreCredentials.cuentas).find((c) => c?.active);
            _amazonCredentials.cuentaActiva = cuentasArray(_amazonCredentials.cuentas).find((c) => c?.active);
            _walmartCredentials.cuentaActiva = cuentasArray(_walmartCredentials.cuentas).find((c) => c?.isActive);
        });

        setAmazonCredentials(_amazonCredentials);
        setMercadolibreCredentials(_mercadolibreCredentials);
        setWalmartCredentials(_walmartCredentials); // Agregar para Walmart
    })();

    return {
        amazonCredentials,
        mercadolibreCredentials,
        walmartCredentials, // Agregar walmartCredentials al estado expuesto
        setAmazonCredentials,
        setMercadolibreCredentials,
        setWalmartCredentials // Exponer setWalmartCredentials
    }
});

export default useMarketplaceCredentials;